import type { Product } from '../../../data/product';
import { formatUnitsQuantity } from '../../../helpers/format-quantity';
import { Tooltip } from '../../popover/tooltip';
import { StatusCell } from '../../status/status-cell';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const QOH: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'QOH Units',
  minWidth: 50,
  accessorFn: (product) => formatUnitsQuantity(product.inventory_qty),
  toCSV: (product) => ({
    'QOH Units': product.inventory_qty.toFixed(0),
  }),
  cell: ({ item: product, value }) => {
    if (product.inventory_qty < 0) {
      return (
        <Tooltip content="Inventory is negative, accurate counts are required for ordering.">
          <StatusCell variant="danger">{value}</StatusCell>
        </Tooltip>
      );
    }

    return <span className="text-accent-500 font-semibold tabular-nums">{value}</span>;
  },
  gloss: 'Units in inventory as of your last count.',
});
